import { useRouter } from "next/router";
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { RecentGamesService } from "service/RecentGamesService";
import useRequestFullScreen from "hooks/useRequestFullScreen";

export const GameContext = createContext(null);

export function useGameContext() {
  return useContext(GameContext);
}

export default function GameProvider({ children }) {
  const { exitFullScreen } = useRequestFullScreen();
  const [showGame, setShowGame] = useState(false);
  const gameIdRef = useRef(null);
  const router = useRouter();
  function setGameId(gameId) {
    gameIdRef.current = gameId;
    RecentGamesService.addGame(gameId, new Date());
  }
  const value = {
    showGame,
    setShowGame,
    setGameId,
    gameId: gameIdRef?.current,
  };
  //   on page change , reset showGame to false
  useEffect(() => {
    setShowGame(false);
    return () => {
      setShowGame(false);
      gameIdRef.current = null;
    };
  }, [router.asPath]);

  useEffect(() => {
    if (showGame) return;
    try {
      exitFullScreen();
    } catch (err) {}
  }, [showGame, exitFullScreen]);
  return (
    <GameContext.Provider value={value}>
      <>{children}</>
    </GameContext.Provider>
  );
}
